import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row mb-10" }
const _hoisted_4 = { class: "col-md-3 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-5 mb-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-12 mb-3" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-md-12 m-10" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "border border-primary mb-10" }
const _hoisted_15 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_16 = { class: "col-md-5" }
const _hoisted_17 = { class: "d-flex float-end" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "col-md-2 mb-2" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = {
  key: 0,
  class: "d-block text-black fw-semibold"
}
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_26 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_27 = { class: "col-md-4 mb-2" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  key: 0,
  class: "d-block text-black fw-semibold"
}
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-md-5 mb-2" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = {
  key: 0,
  class: "d-block text-black fw-semibold"
}
const _hoisted_36 = { class: "" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  ref: "submitButton",
  class: "btn btn-primary me-5",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Enregistrement d'un magasin")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "magasinForm",
        onSubmit: _ctx.addMagasin,
        "validation-schema": _ctx.magasinSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Code du magasin "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "code",
                  type: "text",
                  modelValue: _ctx.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le code du magasin"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "code",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Nom du magasin "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "nomMagasin",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom magasin"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nomMagasin",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Magasinier "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "user" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.personnelOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le magasinier" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Adresse du magasin "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "adresse",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'adresse"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "adresse",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h4", { class: "fs-5 text-white" }, "Sections / compartiments du magasin")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          disabled: _ctx.isDisable,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRowSection()))
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode("Ajouter une section ")
                        ]), 10, _hoisted_18)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, sectionIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row gx-2",
                        key: sectionIndex
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (sectionIndex == 0)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_21, _cache[9] || (_cache[9] = [
                                  _createTextVNode(" Code Section "),
                                  _createElementVNode("span", { class: "text-danger" }, "*", -1)
                                ])))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.code != null ?
                                                            _ctx.code : 'Code'), 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((section.code) = $event),
                                class: _normalizeClass(_ctx.validateRowProduit(section.code) || _ctx.validateDupliacat(section.code)
                                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                                        : 'form-control shadow-none fs-md-15 text-black '),
                                placeholder: "Entrer le nom de la section",
                                "aria-label": "Sizing example input",
                                "aria-describedby": "inputGroup-sizing-sm"
                              }, null, 10, _hoisted_24), [
                                [_vModelText, section.code]
                              ])
                            ]),
                            (_ctx.validateRowProduit(section.code))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Le code de la section est obligatoire. "))
                              : _createCommentVNode("", true),
                            (section.code && _ctx.validateDupliacat(section.code))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Le code de la section doit être unique. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            (sectionIndex == 0)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_29, _cache[10] || (_cache[10] = [
                                  _createTextVNode(" Nom Section "),
                                  _createElementVNode("span", { class: "text-danger" }, "*", -1),
                                  _createElementVNode("span", { class: "text-danger" }, "*", -1)
                                ])))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((section.nomMagasin) = $event),
                                class: _normalizeClass(_ctx.validateRowProduit(section.nomMagasin)
                                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                                        : 'form-control shadow-none fs-md-15 text-black '),
                                placeholder: "Entrer le nom de la section",
                                "aria-label": "Sizing example input",
                                "aria-describedby": "inputGroup-sizing-sm"
                              }, null, 10, _hoisted_31), [
                                [_vModelText, section.nomMagasin]
                              ])
                            ]),
                            (_ctx.validateRowProduit(section.nomMagasin))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Le nom de la section est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            (sectionIndex == 0)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_35, _cache[11] || (_cache[11] = [
                                  _createTextVNode(" Indication Section "),
                                  _createElementVNode("span", { class: "text-danger" }, "*", -1),
                                  _createElementVNode("span", { class: "text-danger" }, "*", -1)
                                ])))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((section.adresse) = $event),
                                class: _normalizeClass(_ctx.validateRowProduit(section.adresse)
                                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                                        : 'form-control shadow-none fs-md-15 text-black '),
                                placeholder: "Entrer l'adresse de la section",
                                "aria-label": "Sizing example input",
                                "aria-describedby": "inputGroup-sizing-sm"
                              }, null, 10, _hoisted_37), [
                                [_vModelText, section.adresse]
                              ])
                            ]),
                            (_ctx.validateRowProduit(section.adresse))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, " L'adresse de la section est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass((sectionIndex == 0) ? 'col-md-1 mt-4' : 'col-md-1')
                        }, [
                          _createElementVNode("button", {
                            class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removeRowSection(sectionIndex))
                          }, _cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                          ]), 8, _hoisted_39)
                        ], 2)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("button", _hoisted_40, " Ajouter le magasin ", 512),
          _createElementVNode("button", {
            class: "btn btn-danger",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'ListeMagasin' })))
          }, " Annuler ")
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}